import { render } from "./FaqGroup.vue?vue&type=template&id=792cec80&ts=true"
import script from "./FaqGroup.vue?vue&type=script&lang=ts"
export * from "./FaqGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__